<template>
    <v-card class="editor pa-0 ma-0" elevation='0'>
        <v-card :disabled="editorDisabled" elevation='0'>
            <div class="form-item form-item-width-1 mt-1">
                <label class="form-item-label py-0 mt-0 mr-0">人员编号:</label>
                <v-text-field 
                    class="form-item-value py-0 mr-0 readonly_input_item" 								
                    outlined
                    dense 
                    placeholder=""
                    readonly
                    :value="billData.id==-1?'':billData.id"
                >
                </v-text-field>	
            </div>
            <div class="d-flex flex-row mt-2">
                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">姓名:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0" 								
                        outlined
                        dense 
                        placeholder=""            
                        v-model="billData.name"
                    >
                    </v-text-field>	
                </div>
                <div class="form-item form-item-width-1">
                    <label class="form-item-label py-0 mt-0 mr-0">性别:</label>
                    <v-select 
                        class="form-item-value py-0 mr-0" 								
                        outlined
                        dense 
                        placeholder=""  
                        :items="sexs"
                        item-text="sexName"
                        item-value="sex"                  
                        v-model="billData.sex"
                    >
                    </v-select>	
                </div>
                <div class="form-item form-item-width-2 mt-0">
                    <label class="form-item-label py-0 mt-0 mr-0">手机号码:</label>
                        <v-text-field 
                            class="form-item-value py-0 mr-0 careful_input_item" 								
                            outlined
                            dense 
                            placeholder=""                    
                            v-model="billData.mobile"
                        >
                    </v-text-field>	
                </div>
            </div>
            
            <div class="form-item form-item-width-1 mt-2">
                <label class="form-item-label py-0 mt-0 mr-0">状态:</label>
                    <v-text-field 
                        class="form-item-value py-0 mr-0 readonly_input_item" 								
                        outlined
                        dense 
                        placeholder=""   
                        readonly                                 
                        v-model="billData.statusName"
                    >
                    </v-text-field>	
            </div>
        </v-card>
        <v-data-table :headers="headers"  fixed-header :items="billData.appoints" class="elevation-1 result-table mt-2"
                width="100%" single-select show-select item-key="id"
				v-model="selectedAppoints"			    
                :hide-default-footer='true'
                :disable-pagination='true'
	    >
		</v-data-table>

        <div class="d-flex flex-row mt-2">
            <v-btn icon @click="showAppointRecords = !showAppointRecords"
            >
                <v-icon>{{ showAppointRecords ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
            </v-btn>
            <span class="mt-2 mx-2" @click="showAppointRecords = !showAppointRecords">查看/隐藏 历史任职记录</span>
            
        </div>
        <v-expand-transition>
            <div v-show="showAppointRecords">
                <v-divider></v-divider>
                <v-data-table :headers="appointRecordHeaders"  fixed-header :items="billData.appointRecords" class="elevation-1 result-table mt-2"
                        width="100%" single-select item-key="id"		    
                        :hide-default-footer='true'
                        :disable-pagination='true'
                >
                </v-data-table>
            </div>
        </v-expand-transition>

        <AppointEditDialog  
            ref="appointEditDialog"
            @insertAppointFinished="insertAppointFinished"
        >
        </AppointEditDialog>

    </v-card>
</template>

<script>
    import EditorState from '../../../base/bill/EditorState.js';
    import UserApi from '../../../../api/smp/org/UserApi.js';
    import AppointApi from '../../../../api/smp/org/AppointApi.js';
    import AppointRecordApi from '../../../../api/smp/org/AppointRecordApi.js';
    import AppointEditDialog from './AppointEditDialog.vue';

    export default {
        name:'SmpUserEditor',
        props:['context'],
        components:{
            'AppointEditDialog':AppointEditDialog,
        },
        data () {
            return {
                billData:{appoints:[]},
                editorState:EditorState.BROWSING,

                selectedAppoints:[],
                showAppointRecords:true,

                headers: [
                    {text: '主职/兼职',value: 'mainOrPart',sortable: false,width: 80,divider: true},
                    {text: '级别',align: 'center',sortable: false,value: 'positionLevelName',width: 80,divider: true},
                    {text: '类别',align: 'center',sortable: false,value: 'positionTypeName',width: 80,divider: true},
                    {text: '部门编号',align: 'start',sortable: false,value: 'deptId',width: 120,divider: true},
                    {text: '部门名称',align: 'start',sortable: false,value: 'deptName',width: 120,divider: true},
                    {text: '组织编号',align: 'start',sortable: false,value: 'orgId',width: 120,divider: true},
                    {text: '组织',align: 'start',sortable: false,value: 'orgName',width: 120,divider: true},

                    {text: '任职状态',align: 'start',sortable: false,value: 'positionStatusName',width: 120,divider: true},
                    {text: '任职开始时间',align: 'start',sortable: false,value: 'positionBeginDate',width: 120,divider: true},
                    {text: '任职结束时间',align: 'start',sortable: false,value: 'positionEndDate',width: 120,divider: true},

                ],
                appointRecordHeaders: [
                    {text: '编号',value: 'id',sortable: false,width: 80,divider: true},
                    {text: '主职/兼职',value: 'mainOrPart',sortable: false,width: 80,divider: true},
                    {text: '级别',align: 'center',sortable: false,value: 'positionLevelName',width: 80,divider: true},
                    {text: '类别',align: 'center',sortable: false,value: 'positionTypeName',width: 80,divider: true},
                    {text: '部门编号',align: 'start',sortable: false,value: 'deptId',width: 120,divider: true},
                    {text: '部门名称',align: 'start',sortable: false,value: 'deptName',width: 120,divider: true},
                    {text: '组织编号',align: 'start',sortable: false,value: 'orgId',width: 120,divider: true},
                    {text: '组织',align: 'start',sortable: false,value: 'orgName',width: 120,divider: true},

                    {text: '任职状态',align: 'start',sortable: false,value: 'positionStatusName',width: 120,divider: true},
                    {text: '任职开始时间',align: 'start',sortable: false,value: 'positionBeginDate',width: 120,divider: true},
                    {text: '任职结束时间',align: 'start',sortable: false,value: 'positionEndDate',width: 120,divider: true},

                ],
                sexs:[
                    {sex:'-1',sexName:'未知'},
                    {sex:'0',sexName:'男'},
                    {sex:'1',sexName:'女'},
                ]
            }
        },
        computed:{ 
            editorDisabled(){
                console.log("editorDisabled");
                return (this.editorState!=EditorState.EDITING);
            },
        },
        methods:{
            getContext(){
                return this.context;
            },

            getBill(){
                return this.getContext().bill;
            },
            getMessageDialogHelper(){
                return  this.getContext().messageDialogHelper;
            },
            getBillData(){
                return this.billData;
            },
            getBillId(){
                return this.billData.billId;
            },
            getSignals () {
                return this.context.signals;
            },

            initSignals(){
                this.initCustomCommandAction();
            },
            reloadUserAndAppointAction(userId){
                let me = this;
                let signal = null;
                signal = this.getSignals().browseBillAsked;
                signal.dispatch({id:userId});
            },
            initCustomCommandAction () {
                let me = this;
                let signal = null;
                signal = this.getSignals().customCommandAsked;
                signal.add(function (param) {
                    if(param.command=="RESTORE_APPOINT"){
                        me.restoreAppointAction();
                    }else if(param.command=="STOP_APPOINT"){
                        me.stopAppointAction();
                    }else if(param.command=="INSERT_APPOINT"){
                        me.insertAppointAction(param.options);
                    }
                });
            },

            restoreAppointAction(){
                let appoint = this.getSelectedAppoint();
                if(!appoint)
                    return;
                this.restoreAppoint(appoint);
            },
            stopAppointAction(){
                let appoint = this.getSelectedAppoint();
                if(!appoint)
                    return;
                this.stopAppoint(appoint);
            },
            insertAppointAction(options){
                let billData = this.billData;
                console.log(billData);
                let editDialog = this.$refs.appointEditDialog;
                editDialog.setMode(1);
                editDialog.setOptions(options);
                editDialog.setNewAppointEditing(billData.id,billData.name,billData.mobile);
                editDialog.setVisible(true); 
            },
            insertAppointFinished(appoint,options){
                console.log("insertAppointFinished");
                console.log(appoint);
                console.log(options);
                let me = this;
                me.reloadUserAndAppointAction(me.billData.id);
            },
            clear(){
                this.billData={};
            },

            //--need implement--
            setState(state){
                this.editorState = state;
            },
            getSelectedAppoints(){
                return this.selectedAppoints;
            },
            getSelectedAppoint(){
                if( this.selectedAppoints && this.selectedAppoints.length>0)
                    return this.selectedAppoints[0];
                return null;    
            },
            //可以调用这两个方法来响应任职变化，本次没采用，而是尝试使用SIGNAL触发刷新来显示新数据
            updateAppoint(appoint){
                let me = this;
                if(this.billData && this.billData.appoints){
                    this.billData.appoints.forEach(function(item){
                        if((appoint.userId==item.userId)&&(appoint.deptId==item.deptId)){
                            item.positionStatus = appoint.pointStatus;
                            me.transformRemoteRec(me.billData,me.billData.appoints);
                            return;
                        }
                    });
                }
            },
            insertAppoint(appoint){
                let me = this;
                if(this.billData && this.billData.appoints){
                    this.billData.appoints.push(appoint);
                }
            },
            //-----------------------

            async loadUserDataRemote(userId){
                let me = this;
                console.log(" loadDataRemote UserApi ");
                console.log(userId);
                let getUserResp = await UserApi.getUser({userId:userId,withAppoints:true});
                console.log("load user with appoints returned;");

                console.log(getUserResp);
                
                let data = getUserResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取人员信息失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.user)){
                    throw new Error('获取人员信息失败(无会话数据)');
                    return;
                }
                let user = data.data.user;
                let appoints = user.appoints;
                this.transformRemoteRec(user,appoints);
                return user;
            },
            async loadAppointRecordRemote(userId){
                let me = this;
                
                let getAppointRecordsResp = await AppointRecordApi.queryUserAppointRecord({userId:userId});
                console.log("load appointRecords returned;");

                console.log(getAppointRecordsResp);
                
                let data = getAppointRecordsResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'获取人员任职记录信息失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.appointRecords)){
                    throw new Error('获取人员任职信息失败(无会话数据)');
                    return;
                }
                let appointRecords = data.data.appointRecords;
                this.transformRemoteRec(null,null,appointRecords);
                return appointRecords;
            },
            transformRemoteRec(user,appoints,appointRecords){
                if(user){
                    if(user.status==1)
                        user.statusName="正常";
                    else if(user.status==0)
                        user.statusName="停用";
                    else
                        user.statusName="未知";
                }

                if(appoints){
                    appoints.forEach(function(item){
                        if(item.mainFlag==1){
                            item.mainOrPart='主职';
                        }else{
                            item.mainOrPart='兼职';
                        }

                        if(item && item.positionStatus){
                            if(item.positionStatus==0)
                                item.positionStatusName='停用';
                            else if(item.positionStatus==1)
                                item.positionStatusName='启用';
                            else
                                item.positionStatusName="未知";
                        }else
                            item.positionStatusName="未知";      

                    });
                }

                if(appointRecords){
                    appointRecords.forEach(function(item){
                        if(item.mainFlag==1){
                            item.mainOrPart='主职';
                        }else{
                            item.mainOrPart='兼职';
                        }

                        if(item && item.positionStatus){
                            if(item.positionStatus==0)
                                item.positionStatusName='停用';
                            else if(item.positionStatus==1)
                                item.positionStatusName='启用';
                            else
                                item.positionStatusName="未知";
                        }else
                            item.positionStatusName="未知";      

                    });
                }
            },
            //回调注意传入单据数据信息
            async  loadData(billInfo,loadRemote,loadSuccessCallback,loadFailCallback){
                console.log("person loadData");
                console.log(billInfo);
                let me = this;
                this.clear();
                if(billInfo.id==-1){
                    this.billData = billInfo;
                }else if(!loadRemote){
                    this.billData = billInfo;
                }else{
                    let user=null;
                    //远程加载
                    try{
                        user = await this.loadUserDataRemote(billInfo.id);
                        let appointRecords = await this.loadAppointRecordRemote(billInfo.id);
                        user.appointRecords = appointRecords;
                        me.selectedAppoints=[];
                        
                    }catch(err){
                        console.log(err);
                        me.getMessageDialogHelper().errMsg('错误','加载人员信息失败:'+err.message);
                        loadFailCallback(this.billData);
                        return;
				    };
                    this.billData = user;                    
                }
                loadSuccessCallback(this.billData);
                
            },
            //回调注意传入单据数据信息,建议所有持久化服务程序，执行完后在服务端立即执行查询并返回，节省一次调用
            async saveDataRemote(bill){
                let persistUserResp = await UserApi.persistUser(bill);

                console.log("persist user  returned;");
                console.log(persistUserResp);
                
                let data = persistUserResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'保存人员失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.user)){
                    throw new Error('保存人员时返回无数据');
                    return;
                }
                let user = data.data.user;      
                return user;
            },
            async saveData(saveSuccessCallback,saveFailCallback){
                let me = this;
                let bill=this.billData;
                
                try{
                    let user = await this.saveDataRemote(bill);
                    me.transformRemoteRec(user,user.appoints);
                    saveSuccessCallback(user,true);
                }catch(err){
                    console.log(err);
                    me.getMessageDialogHelper().errMsg('错误','保存人员信息失败:'+err.message);
                    saveFailCallback(this.billData);
                };
                
            },
            deleteData(deleteSuccessCallback,deleteFailCallback){
                let bill={};

                deleteSuccessCallback(bill);
            },
            auditData(auditSuccessCallback,auditFailCallback){
                let bill={};

                auditSuccessCallback(bill);
            },
            cancelAuditData(cancelAuditSuccessCallback,cancelAuditFailCallback){
                let bill={};

                cancelAuditSuccessCallback(bill);
            },
            voidData(voidSuccessCallback,voidFailCallback){
                let bill={};

                voidSuccessCallback(bill);
            },
            cancelVoidData(cancelVoidSuccessCallback,cancelVoidFailCallback){
                let bill={};

                cancelVoidSuccessCallback(bill);
            },
            putOnData(putOnSuccessCallback,putOnFailCallback){
                let bill={};

                putOnSuccessCallback(bill);
            },
            withdrawData(withdrawSuccessCallback,withdrawFailCallback){
                let bill={};

                withdrawSuccessCallback(bill);
            },

            async stopDataRemote(bill){
                let me = this;
                let stopUserResp = await UserApi.stopUser(bill);

                console.log("stop user  returned;");
                console.log(stopUserResp);
                
                let data = stopUserResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'人员停用失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.user)){
                    throw new Error('人员停用时返回无数据');
                    return;
                }
                let user = data.data.user;      
                me.transformRemoteRec(user,user.appoints);
                return user;
            },
            async stopData(stopSuccessCallback,stopFailCallback){
                let me = this;
                let bill=this.billData;
                
                try{
                    let user = await this.stopDataRemote(bill);
                    stopSuccessCallback(user,true);
                }catch(err){
                    console.log(err);
                    me.getMessageDialogHelper().errMsg('错误','人员停用失败:'+err.message);
                    stopFailCallback(this.billData);
                };
                
            },

            async restoreDataRemote(bill){
                let me = this;
                let restoreUserResp = await UserApi.restoreUser(bill);

                console.log("restore user  returned;");
                console.log(restoreUserResp);
                
                let data = restoreUserResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'人员启用失败':msg;
                    throw new Error(msg);
                    return;
                }
                if((!data.data)||(!data.data.user)){
                    throw new Error('人员启用时返回无数据');
                    return;
                }
                let user = data.data.user;      
                me.transformRemoteRec(user,user.appoints);
                return user;
            },
            async restoreData(restoreSuccessCallback,restoreFailCallback){
                let me = this;
                let bill=this.billData;
                
                try{
                    let user = await this.restoreDataRemote(bill);
                    restoreSuccessCallback(user,true);
                }catch(err){
                    console.log(err);
                    me.getMessageDialogHelper().errMsg('错误','人员启用失败:'+err.message);
                    restoreFailCallback(this.billData);
                };
                
            },

            //用于指示按钮可用性,不在此
            canEdit(){
                return true;    
            },
            canDelete(){
                return false;
            },
            
            canSave(){
                return true;
            },
            canAudit(){
                return false;
            },
            canCancelAudit(){
                return false;
            },
            canVoid(){
                return false;
            },
            canCancelVoid(){
                return false;
            },
            canPutOn(){
                return false;
            },
            canWithdraw(){
                return false;
            },

            canRestore(){
                if(this.billData.status==0)
                    return true;
                return false;    
            },
            canStop(){
                if(this.billData.status==1)
                    return true;
                return false;    
            },

            //非标准消息，发起浏览加载请求，而不是使用回调
            async stopAppoint(appoint){
                let me = this;
                
                try{
                    let appointRet = await this.stopAppointRemote(appoint);
                    //restoreSuccessCallback(user);
                    me.reloadUserAndAppointAction(me.billData.id);
                }catch(err){
                    console.log(err);
                    me.getMessageDialogHelper().errMsg('错误','停用任职发生了异常:'+err.message);
                    //restoreFailCallback(this.bill);
                    me.reloadUserAndAppointAction(me.billData.id);
                };
            },
            async stopAppointRemote(appoint){
                let stopAppointResp = await AppointApi.stopAppoint(appoint);

                console.log("stop appoint  returned;");
                console.log(stopAppointResp);
                
                let data = stopAppointResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'任职停用异常':msg;
                    throw new Error(msg);
                    return;
                }
                // if((!data.data)||(!data.data.appoint)){
                //     throw new Error('任职停用时无返回数据');
                //     return;
                // }
                let appointRet = data.data.appoint;      
                return appointRet;
            },
            async restoreAppoint(appoint){
                let me = this;
                
                try{
                    let appointRet = await this.restoreAppointRemote(appoint);
                    //restoreSuccessCallback(user);
                    me.reloadUserAndAppointAction(me.billData.id);
                }catch(err){
                    console.log(err);
                    me.getMessageDialogHelper().errMsg('错误','恢复任职发生了异常:'+err.message);
                    //restoreFailCallback(this.bill);
                    me.reloadUserAndAppointAction(me.billData.id);
                };
            },
            async restoreAppointRemote(appoint){
                let restoreAppointResp = await AppointApi.restoreAppoint(appoint);

                console.log("restore appoint  returned;");
                console.log(restoreAppointResp);
                
                let data = restoreAppointResp.data;
                if((!data)||(!(data.code))||(data.code!=200)){
                    let msg=data.msg;
                    msg = ((!msg)||(msg==''))?'恢复停用异常':msg;
                    throw new Error(msg);
                    return;
                }
                // if((!data.data)||(!data.data.appoint)){
                //     throw new Error('恢复停用时无返回数据');
                //     return;
                // }
                let appointRet = data.data.appoint;      
                return appointRet;
            },
            insertAppoint(appoint){},
            insertAppointRemote(appoint){}
        },
        created(){
            console.log("user Editor created");
            this.billData = this.getBill().getEmptyData();
            this.initSignals();
        },
        mounted(){ 
            console.log("user Editor mounted");
            if(!this.billData)
                this.billData = this.getBill().getEmptyData();
        },
    }
</script>

<style scoped>
    .readonly_input_item{
		background-color:lightgray;
	}
	.careful_input_item{
		background-color:lightblue;
	}
    .active-tab-view{
		padding:0px;
		margin: 0px;
		width:100%;
		height:100%;
    overflow-y: auto;
    overflow-x: hidden;
	}
	
	.tabViewContainer{
        /*
		overflow: scroll;
		width:100%;
		height:100%;
        */
        visibility: inherit;
	}
	.active-tab{
		background-color: lightblue;
	}

</style>
